/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NodataReturnOrderGoodsDto } from './NodataReturnOrderGoodsDto';
import {
    NodataReturnOrderGoodsDtoFromJSON,
    NodataReturnOrderGoodsDtoFromJSONTyped,
    NodataReturnOrderGoodsDtoToJSON,
    NodataReturnOrderGoodsDtoToJSONTyped,
} from './NodataReturnOrderGoodsDto';

/**
 * 
 * @export
 * @interface NodataInfoResVo
 */
export interface NodataInfoResVo {
    /**
     * 记录ID
     * @type {number}
     * @memberof NodataInfoResVo
     */
    id?: number;
    /**
     * 用户名称
     * @type {string}
     * @memberof NodataInfoResVo
     */
    userName?: string;
    /**
     * 用户编码
     * @type {string}
     * @memberof NodataInfoResVo
     */
    userCode?: string;
    /**
     * 国家ID
     * @type {number}
     * @memberof NodataInfoResVo
     */
    nationId?: number;
    /**
     * 仓库ID
     * @type {number}
     * @memberof NodataInfoResVo
     */
    warehouseId?: number;
    /**
     * 快递单号
     * @type {string}
     * @memberof NodataInfoResVo
     */
    trackingNumber?: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof NodataInfoResVo
     */
    name?: string;
    /**
     * 库位明细ID
     * @type {number}
     * @memberof NodataInfoResVo
     */
    locationDetailId?: number;
    /**
     * 库位明细编码
     * @type {string}
     * @memberof NodataInfoResVo
     */
    locationDetailCode?: string;
    /**
     * 无数据状态
     * @type {number}
     * @memberof NodataInfoResVo
     */
    nodataStatus?: number;
    /**
     * 数量
     * @type {number}
     * @memberof NodataInfoResVo
     */
    quantity?: number;
    /**
     * 到付运费
     * @type {number}
     * @memberof NodataInfoResVo
     */
    carriageForward?: number;
    /**
     * coupang退货标识 0:否 1:是
     * @type {number}
     * @memberof NodataInfoResVo
     */
    returnFromCoupang?: number;
    /**
     * coupang入库码
     * @type {string}
     * @memberof NodataInfoResVo
     */
    coupangInboundCode?: string;
    /**
     * 是否已通过手机端提交返送订单；为true时关闭商品编辑入口
     * @type {boolean}
     * @memberof NodataInfoResVo
     */
    returnOrderSubmitted?: boolean;
    /**
     * 手机无数据返送生成的订单ID，未提交时为空
     * @type {number}
     * @memberof NodataInfoResVo
     */
    returnOrderId?: number;
    /**
     * 手机无数据返送生成的订单编号，未提交时为空
     * @type {string}
     * @memberof NodataInfoResVo
     */
    returnOrderCode?: string;
    /**
     * 返送入库进程：未提交固定1待入库，提交后取绑定快递实际状态；绑定缺失时为空
     * @type {number}
     * @memberof NodataInfoResVo
     */
    parcelStatus?: number;
    /**
     * 返送入库进程名称，按当前语言返回
     * @type {string}
     * @memberof NodataInfoResVo
     */
    parcelStatusName?: string;
    /**
     * 已提交返送订单商品及本次申请数量；未提交为空列表，用于重新进入页面恢复展示
     * @type {Array<NodataReturnOrderGoodsDto>}
     * @memberof NodataInfoResVo
     */
    goods?: Array<NodataReturnOrderGoodsDto>;
}

/**
 * Check if a given object implements the NodataInfoResVo interface.
 */
export function instanceOfNodataInfoResVo(value: object): value is NodataInfoResVo {
    return true;
}

export function NodataInfoResVoFromJSON(json: any): NodataInfoResVo {
    return NodataInfoResVoFromJSONTyped(json, false);
}

export function NodataInfoResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataInfoResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'nationId': json['nationId'] == null ? undefined : json['nationId'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'name': json['name'] == null ? undefined : json['name'],
        'locationDetailId': json['locationDetailId'] == null ? undefined : json['locationDetailId'],
        'locationDetailCode': json['locationDetailCode'] == null ? undefined : json['locationDetailCode'],
        'nodataStatus': json['nodataStatus'] == null ? undefined : json['nodataStatus'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'carriageForward': json['carriageForward'] == null ? undefined : json['carriageForward'],
        'returnFromCoupang': json['returnFromCoupang'] == null ? undefined : json['returnFromCoupang'],
        'coupangInboundCode': json['coupangInboundCode'] == null ? undefined : json['coupangInboundCode'],
        'returnOrderSubmitted': json['returnOrderSubmitted'] == null ? undefined : json['returnOrderSubmitted'],
        'returnOrderId': json['returnOrderId'] == null ? undefined : json['returnOrderId'],
        'returnOrderCode': json['returnOrderCode'] == null ? undefined : json['returnOrderCode'],
        'parcelStatus': json['parcelStatus'] == null ? undefined : json['parcelStatus'],
        'parcelStatusName': json['parcelStatusName'] == null ? undefined : json['parcelStatusName'],
        'goods': json['goods'] == null ? undefined : ((json['goods'] as Array<any>).map(NodataReturnOrderGoodsDtoFromJSON)),
    };
}

export function NodataInfoResVoToJSON(json: any): NodataInfoResVo {
    return NodataInfoResVoToJSONTyped(json, false);
}

export function NodataInfoResVoToJSONTyped(value?: NodataInfoResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'nationId': value['nationId'],
        'warehouseId': value['warehouseId'],
        'trackingNumber': value['trackingNumber'],
        'name': value['name'],
        'locationDetailId': value['locationDetailId'],
        'locationDetailCode': value['locationDetailCode'],
        'nodataStatus': value['nodataStatus'],
        'quantity': value['quantity'],
        'carriageForward': value['carriageForward'],
        'returnFromCoupang': value['returnFromCoupang'],
        'coupangInboundCode': value['coupangInboundCode'],
        'returnOrderSubmitted': value['returnOrderSubmitted'],
        'returnOrderId': value['returnOrderId'],
        'returnOrderCode': value['returnOrderCode'],
        'parcelStatus': value['parcelStatus'],
        'parcelStatusName': value['parcelStatusName'],
        'goods': value['goods'] == null ? undefined : ((value['goods'] as Array<any>).map(NodataReturnOrderGoodsDtoToJSON)),
    };
}

